import {Injectable} from '@angular/core';
import {ParentService} from "./ParentService";
import {TranslationEntity} from "../model/TranslationEntity";
import {catchError} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {StudentEntity} from "../model/StudentEntity";
import {SubscriptionEntity} from "../model/SubscriptionEntity";
import {ExamEntity} from "../model/ExamEntity";
import {TutorExamEntity} from "../model/TutorExamEntity";
import {ExamsResultsDto} from "../model/ExamsResultsDto";
import {ExamResultSubjectEntity} from "../model/ExamResultSubjectEntity";
import {ExamResultTopicEntity} from "../model/ExamResultTopicEntity";
import {CommonTutorDto} from "../dto/CommonTutorDto";
import {TutorFollowupEntity} from "../model/TutorFollowupEntity";
import {ExamAnswerDetailDto} from "../dto/ExamAnswerDetailDto";

@Injectable()
export class TutorService extends ParentService{

  public getStudents(){
    return this.http.get<StudentEntity[]>(this.shared.MAGNAMENT_URL+'/getTutorStudents/'+this.shared.CURRENT_TUTOR.id, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }
  public getStudentSubscription(studentId){
    return this.http.get<SubscriptionEntity[]>(this.shared.MAGNAMENT_URL+'/getStudentSubscriptions/'+this.shared.CURRENT_TUTOR.id+'/'+studentId, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }
  public getSubscriptionExams(subscriptionId){
    return this.http.get<ExamsResultsDto[]>(this.shared.MAGNAMENT_URL+'/getSubscriptionExams/'+subscriptionId, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }
  public getExamSubjectResult(examId){
    return this.http.get<ExamResultSubjectEntity[]>(this.shared.MAGNAMENT_URL+'/getExamSubjectResult/'+examId, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }
  public getExamTopicResult(examId){
    return this.http.get<ExamResultTopicEntity[]>(this.shared.MAGNAMENT_URL+'/getExamTopicResult/'+examId, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }
  public getExamAnswerDetail(examId){
    return this.http.get<ExamAnswerDetailDto[]>(this.shared.MAGNAMENT_URL+'/getExamAnswerDetail/'+examId, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }
  public getCommonTutorData(){
    return this.http.get<CommonTutorDto>(this.shared.MAGNAMENT_URL+'/getCommonTutorData', this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public getSubscriptionStatistics(ref){
    return this.http.get<CommonTutorDto>(this.shared.MAGNAMENT_URL+'/getTutorVideosInfo/'+ref, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public getTutorFollowup(id){
    return this.http.get<TutorFollowupEntity[]>(this.shared.MAGNAMENT_URL+'/getTutorFollowup/'+id, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public saveTutorFollowup(tfe){
    return this.http.post<TutorFollowupEntity>(this.shared.MAGNAMENT_URL+'/saveTutorFollowup', tfe, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }
}
